import { Component, OnInit, Output } from '@angular/core';
import { EventEmitter } from 'events';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { RMA } from '../../../models/RMA';
import { RMAResponse } from '../../../models/RMAResponse';
import { HttpService } from '../../../services/HttpService';
import { ModalComponent } from '../../modal/modal.component';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { HttpResponse } from '@angular/common/http';
import { RMAItem } from '../../../models/RMAItem';
import { User } from '../../../models/User';
import { GlobalService } from '../../../services/global';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rma-summary',
  templateUrl: './rma-summary.component.html',
  styleUrls: ['./rma-summary.component.css']
})
export class RmaSummaryComponent implements OnInit {
  @Output() CloseEventEmitter: EventEmitter = new EventEmitter();
  rma: RMA;
  rmaItem: RMAItem;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  CurUser: User;
  faFileLines = faFileLines;
  constructor( private matDialog: MatDialog, private http:HttpService, private global:GlobalService, private router:Router) { }

  ngOnInit(): void {
    
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA Detail Summary", "Load", this.rma.RMANumber);
    });
    
  }

  SetRMA(r: RMA, item:RMAItem) {
    this.rma = r;
    this.rmaItem = item;
  }

   RMARespond_Click() {
    var dialogConfig = this.GetDialogConfig("RMARespond");

     var rmaObject = {
       type: "RMAResponse", object: { rma: this.rma, rmaItem: this.rmaItem } };
    dialogConfig.data = rmaObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

     this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
       var response = <RMAResponse>event;
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA Detail Summary", "RMA Respond",response.RMANumber);
      
      this.rmaItem.Response = response;
      var success = this.SubmitResponse(response);
      if (success) {
        this.CurrentOpenDialog.close();
      }
    });

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  async SubmitResponse(response:RMAResponse):Promise<boolean> {
    if (response.Action != "" && response.RMANumber != null) {
      return await this.http.SubmitRMAResponse(response, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {
          return true;
        }
        else {
          return false;
        }
      });
    }
  }

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "80%";
    dialogConfig.width = "70%";

    return dialogConfig;
  }

  DownloadVerification() {
    if (this.rma.RMAVerificationPath.length > 0) {
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA Detail Summary", "Download RMA Verification", this.rma.RMANumber);
      var rmaVeriName = this.rmaItem.RMANumber;
      var veriDatecutoff = new Date(2025, 8, 23, 0, 0, 0, 0);
      if (new Date(this.rmaItem.CreateDate).getTime() > veriDatecutoff.getTime()) {
        rmaVeriName += "-" + this.rmaItem.RMALine.toString();
      }
      rmaVeriName += ".pdf";

      this.http.DownloadRMAVerification(rmaVeriName).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = this.rma.RMANumber + "-" + this.rmaItem.RMALine.toString() + ".pdf";
        a.click();

      });
    }
  }

  DownloadEval() {
    if (this.rmaItem.RMAEvalPath.length > 0) {
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA Detail Summary", "Download RMA Eval",this.rmaItem.RMANumber);
      this.http.DownloadRMAEvaluation(this.rmaItem).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = this.rma.RMANumber + ".pdf";
        a.click();
      });
    }
  }

  GoToOrder(repairOrder: string) {
    if (repairOrder && repairOrder.length > 0) {
      this.CloseEventEmitter.emit("close");
      this.router.navigateByUrl('/orderstatus', { state: { orderNumber: repairOrder } });
    }
  }

}
